export default __webpack_public_path__ + "static/media/pic61.d4b1bdba.JPG";